import React from 'react';
import { useStripes } from '@folio/stripes/core';
import ImportNavButton from './ImportNavButton';
import SettingsNavButton from './SettingsNavButton';
import ValidationRulesNavButton from './ValidationRulesNavButton';
import DerivationRulesNavButton from './DerivationRulesNavButton';
import SemanticCatalogNavButton from './SemanticCatalogNavButton';
import GuidanceTextsNavButton from './GuidanceTextsNavButton';
import VocabularyTypesNavButton from './VocabularyTypesNavButton';
import OaiHarvestNavButton from './OaiHarvestNavButton';
import { SETTINGS_CAPABILITY } from '../utils/settingsAccess';
/**
 * Settings sub-navigation, shown at the top of the settings pane (CZNA-245,
 * CZNA-314, CZNA-365). Lists the settings destinations (Imports, Form settings,
 * Validation rules, Derivation rules, Ontology, Help texts, Vocabularies), each
 * reusing its standalone per-item button so they keep the shared
 * active-highlight contract (`buttonStyle='primary'` + `aria-current='page'`
 * when active) and their own permission gating.
 *
 * <p>Every destination but Slovníky is a route registered only under
 * {@link SETTINGS_CAPABILITY} (CZNA-1448), so a vocabulary administrator — who reaches
 * this pane for Slovníky alone (CZNA-1470) — must not see buttons leading nowhere.
 * Sklizeň OAI (CZNA-1562) likewise gates on its own permission, the one its endpoints
 * require, not on that capability.
 *
 * <p>The former "Zpět" entry was removed in CZNA-314: top-level navigation
 * (including "Přehled" / dashboard and the ⚙ settings entry) now lives in the
 * persistent {@link ActivityRail}, so a back-out affordance here is redundant.
 */
var SettingsNavList = function () {
    var stripes = useStripes();
    var isAuthorityAdmin = stripes.hasPerm(SETTINGS_CAPABILITY);
    return (React.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: '4px' } },
        isAuthorityAdmin && (React.createElement(React.Fragment, null,
            React.createElement(ImportNavButton, null),
            React.createElement(SettingsNavButton, null),
            React.createElement(ValidationRulesNavButton, null),
            React.createElement(DerivationRulesNavButton, null),
            React.createElement(SemanticCatalogNavButton, null),
            React.createElement(GuidanceTextsNavButton, null))),
        React.createElement(VocabularyTypesNavButton, null),
        React.createElement(OaiHarvestNavButton, null)));
};
export default SettingsNavList;
